export * from './common-constants.js'
export let APP_NAME = process.env.REACT_APP_NAME
export let APP_API = process.env.REACT_APP_API
export let APP_ENV = process.env.REACT_APP_ENV
export let APP_VERSION = process.env.REACT_APP_VERSION
export let LOCAL_DEV_IP = process.env.REACT_APP_LOCAL_DEV_IP
export let SENTRY_KEY = process.env.REACT_APP_SENTRY_KEY
export let S3_BUCKET_VAXIOM = process.env.REACT_APP_S3_BUCKET_VAXIOM
export let S3_BUCKET_FILES = process.env.REACT_APP_S3_BUCKET_FILES
